import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Voucher } from 'src/models/DTO/vouchers/voucher';
import { VoucherItem } from 'src/models/DTO/vouchers/voucherItem';
import { VouchersService } from 'src/services/request/vouchers/vouchers.service';
import { HistoryService } from 'src/services/state/history/history.service';

@Component({
  selector: 'app-vouchers',
  templateUrl: './vouchers.component.html',
  styleUrls: ['./vouchers.component.css']
})
export class VouchersComponent extends HistoryBaseComponent implements OnInit {
  private _vouchers: Voucher = { data: [] };

  constructor(
    private modalService: NgbModal,
    private voucherService: VouchersService,
    protected location: Location,
    protected historyService: HistoryService
  ) {
    super(location, historyService);

    this.voucherService.getVouchersForUser().subscribe((vouchers) => {
      this._vouchers = vouchers;
    });
  }

  ngOnInit(): void {}

  get vouchers(): Voucher {
    return this._vouchers;
  }

  public getVoucherAmountBase(voucher: VoucherItem): number {
    return Number(voucher?.amount) || 0;
  }

  public fixVoucherDate(voucherDate: string): string {
    const fixedDate = new Date(voucherDate).toLocaleDateString();
    return 'Получен на: ' + fixedDate;
  }

  public inviteAndEarn(): void {
    alert('Not implemented');
  }

  public returnToFixed(amount: string): string {
    return Number.parseInt(amount, 10).toString();
  }

  public returnDate(date: string): string {
    return new Date(date).toLocaleDateString();
  }

  public openInfo(modal: any): void {
    this.modalService.open(modal, {
      size: 'sm',
      windowClass: 'loginModal'
    });
  }
}
